import { IntegrationCore, onLoEvent } from '@luckyorange/integration-core'
import { Optimizely, OptimizelyData, OptimizelyState } from 'optimizely-types'
declare global {
  interface Window {
    optimizely?: Optimizely; // TODO: type optimizely
  }
}

const core = new IntegrationCore([
  {
    name: 'integration-optimizely',
    isActive ({ _window }: { _window: Window }) {
      const hasOptimizely = !!_window.optimizely

      return hasOptimizely
    },
    start ({ _window, LO }: { _window: Window; LO: any }) {
      const optimizely = _window.optimizely!
      const optimizelyData = optimizely.get('data') as OptimizelyData

      // TODO: reduce the objects to only contain experiment name, id, and variations
      const experiments = optimizelyData.experiments

      async function callback () {
        console.log('callback')
        await LO.$internal.ready('events')
        const optimizelyState = optimizely.get('state') as OptimizelyState
        const experimentStates = optimizelyState.getExperimentStates({
          isActive: true
        })

        Object.keys(experimentStates).forEach((experimentId) => {
          const variationId = experimentStates[experimentId].variation.id
          const meta = {
            experimentId,
            variationId
          }
          LO.$internal.events.track('A/B Testing Experiment Detected', meta, { namespace: 'optimizely' })
        })
      }

      onLoEvent('Page Viewed', callback)
      callback()
    }
  }
])

declare global {
  interface Window { LOQ: any[]; }
}

window.parent.LOQ = window.parent.LOQ || []
window.parent.LOQ.push(['ready', (LO: any) => {
  core.init()
}])
